// extracted by mini-css-extract-plugin
export var divider = "_tq-0";
export var systemMessage = "_tq-1";